'use strict';

angular.module('adelementAdminApp')
    .controller('ProspectiveUsersController', function ($scope, $state, ProspectiveUsers, ParseLinks) {

        $scope.prospectiveUserss = [];
        $scope.predicate = 'id';
        $scope.reverse = true;
        $scope.page = 1;
        $scope.loadAll = function() {
            ProspectiveUsers.query({page: $scope.page - 1, size: 20, sort: [$scope.predicate + ',' + ($scope.reverse ? 'asc' : 'desc'), 'id']}, function(result, headers) {
                $scope.links = ParseLinks.parse(headers('link'));
                $scope.totalItems = headers('X-Total-Count');
                $scope.prospectiveUserss = result;
            });
        };
        $scope.loadPage = function(page) {
            $scope.page = page;
            $scope.loadAll();
        };
        $scope.loadAll();


        $scope.refresh = function () {
            $scope.loadAll();
            $scope.clear();
        };

        $scope.clear = function () {
            $scope.prospectiveUsers = {
                firstName: null,
                lastName: null,
                email: null,
                phoneNo: null,
                country: null,
                city: null,
                companyName: null,
                userTitle: null,
                websiteUrl: null,
                monthlyWebsiteVisitors: null,
                appUrl: null,
                monthlyAppUsers: null,
                prefferedTime: null,
                timeSlot: null,
                timezone: null,
                message: null,
                id: null
            };
        };
    });
